import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from 'ui/component/Button.tsx';

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <main className="flex items-center justify-center">
      <div className="absolute inset-0 -z-30 flex flex-col items-center justify-center gap-16 bg-blue-light">
        <img src="/404.svg" alt={t('errors.notFound')} />
        <Link to="/">
          <Button className="blue">{t('actions.goToHomepage')}</Button>
        </Link>
      </div>
    </main>
  );
};
